const PaymentPage = () => {
  
  return (
    <div style={styles.container}>
        <h1>This is a Payment Gateway Page</h1>
    </div>
  );
};

const styles = {
  container: {
    background: "#f5f5f5",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  
};

export default PaymentPage;
